module.exports = __webpack_public_path__ + "img/Promo_du_Jour.c352fe3b.png";